import { render } from "./IphoneHeaderBar.vue?vue&type=template&id=2e77fbd3&scoped=true"
import script from "./IphoneHeaderBar.vue?vue&type=script&lang=js"
export * from "./IphoneHeaderBar.vue?vue&type=script&lang=js"

import "./IphoneHeaderBar.vue?vue&type=style&index=0&id=2e77fbd3&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e77fbd3"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
